module.exports = __webpack_public_path__ + "img/checkbox-default-error.47a215b.svg";